import React, { useEffect } from "react";
import styled from "styled-components";
import Announcements from "../components/Announcements";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { mobile, tabletLandscape, tabletPortrait } from "../responsive";

const Container = styled.div``;

const Title = styled.h1`
  margin: 20px;
`;

const Wrapper = styled.div`
  margin: 30px;
`;

const SectionTitle = styled.p`
  font-size: 22px;
  font-weight: bold;
  text-decoration: underline;
  color: #ff7a00;
  text-align: center;
  margin: 30px 0;
`;

const SubTitle = styled.p`
  font-size: 18px;
  font-weight: bold;
  color: #4d4dea;
  text-decoration: underline;
  margin-top: 20px;
`;

const Description = styled.p`
  font-size: 16px;
  line-height: 1.7;
  margin: 10px 0;
`;

const ImageRow = styled.div`
  display: flex;
  justify-content: space-around;
  flex-flow: row wrap;
  margin: 40px 0;
`;

const ImageBox = styled.div`
  margin-bottom: 15px;
`;

const MiddleContent = styled.div`
  margin: 20px 0;
`;

const MiddleTitle = styled.div`
  font-size: 22px;
  font-weight: bold;
  text-decoration: underline;
  color: #2cc168;
  margin: 30px 0;
  text-align: center;
`;

const ContentRow = styled.div`
  display: flex;
  flex-direction: row;
  ${mobile({ flexFlow: "row wrap" })}
`;

const ContentBox = styled.div`
  flex: 1;
  margin: 25px;
`;

const ContentBoxTitle = styled.div`
  font-weight: 700;
  color: #073763;
  text-decoration: underline;
  margin-bottom: 10px;
`;

const ContentBoxDesc = styled.div`
  font-size: 15px;
  line-height: 1.6;
`;

const BottomContainer = styled.div`
  margin-top: 40px;
`;

const BottomTitle = styled.div`
  font-weight: 800;
  color: #548dd4;
  margin-bottom: 15px;
  font-size: 20px;
`;

const RoboticsAiLabs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container>
      <Announcements />
      <Navbar />

      <Title>Robotics & AI Labs for Schools & Colleges</Title>

      <Wrapper>
        <SectionTitle>Future-Ready Robotics & AI Innovation Labs</SectionTitle>

        <Description>
          Impact Technologies provides end-to-end **Robotics and Artificial
          Intelligence Lab setup** for schools, colleges, universities, and
          training institutes. Our labs are designed to bridge the gap between
          theoretical learning and real-world applications by empowering
          students with hands-on experience in emerging technologies.
        </Description>

        <ImageRow>
          <ImageBox>
            <img src={require("../Assets/Labs/lab1.png")} height={200} width={250} alt="" />
          </ImageBox>
          <ImageBox>
            <img src={require("../Assets/Labs/lab2.png")} height={200} width={250} alt="" />
          </ImageBox>
          <ImageBox>
            <img src={require("../Assets/Labs/lab3.png")} height={200} width={250} alt="" />
          </ImageBox>
          <ImageBox>
            <img src={require("../Assets/Labs/lab4.png")} height={200} width={250} alt="" />
          </ImageBox>
        </ImageRow>

        <SubTitle>What is a Robotics & AI Lab?</SubTitle>
        <Description>
          A Robotics & AI Lab is an interactive learning environment where
          students design, build, program, and test intelligent machines and
          software systems. It integrates **robotics, electronics, programming,
          artificial intelligence, machine learning, IoT, and automation** into
          a single ecosystem.
        </Description>

        <MiddleContent>
          <MiddleTitle>LAB EQUIPMENT & KITS PROVIDED</MiddleTitle>

          <ContentRow>
            <ContentBox>
              <ContentBoxTitle>Robotics Kits</ContentBoxTitle>
              <ContentBoxDesc>
                <ul>
                  <li>Educational Robotics Kits (Beginner to Advanced)</li>
                  <li>Line Follower, Obstacle Avoider & Smart Car Kits</li>
                  <li>Robotic Arm & Pick-and-Place Kits</li>
                  <li>Humanoid & AI Vision Robot Kits</li>
                  <li>Drone & Autonomous Vehicle Kits</li>
                </ul>
              </ContentBoxDesc>
            </ContentBox>

            <ContentBox>
              <ContentBoxTitle>Microcontrollers & Computing</ContentBoxTitle>
              <ContentBoxDesc>
                <ul>
                  <li>Arduino UNO / Mega / Nano Boards</li>
                  <li>ESP32 / ESP8266 IoT Boards</li>
                  <li>Raspberry Pi 4 & AI Compute Modules</li>
                  <li>Jetson Nano (AI & Vision Processing)</li>
                </ul>
              </ContentBoxDesc>
            </ContentBox>

            <ContentBox>
              <ContentBoxTitle>Sensors & Modules</ContentBoxTitle>
              <ContentBoxDesc>
                <ul>
                  <li>Ultrasonic, IR, PIR & Proximity Sensors</li>
                  <li>Gas, Temperature, Humidity & Light Sensors</li>
                  <li>Camera & AI Vision Modules</li>
                  <li>Bluetooth, Wi-Fi, RFID & GPS Modules</li>
                </ul>
              </ContentBoxDesc>
            </ContentBox>
          </ContentRow>

          <ContentRow>
            <ContentBox>
              <ContentBoxTitle>AI & Software Tools</ContentBoxTitle>
              <ContentBoxDesc>
                <ul>
                  <li>Python, C/C++, Scratch Programming</li>
                  <li>Machine Learning & AI Fundamentals</li>
                  <li>Computer Vision with OpenCV</li>
                  <li>IoT Dashboards & Cloud Integration</li>
                </ul>
              </ContentBoxDesc>
            </ContentBox>

            <ContentBox>
              <ContentBoxTitle>Lab Infrastructure</ContentBoxTitle>
              <ContentBoxDesc>
                <ul>
                  <li>Workstations & Experiment Tables</li>
                  <li>Power Supplies & Safety Equipment</li>
                  <li>Project Displays & Demo Units</li>
                  <li>Complete Curriculum & Lab Manuals</li>
                </ul>
              </ContentBoxDesc>
            </ContentBox>
          </ContentRow>
        </MiddleContent>

        <BottomContainer>
          <BottomTitle>HOW THIS ENHANCES THE EDUCATION SYSTEM</BottomTitle>
          <Description>
            Robotics & AI labs transform traditional education into an
            **experiential learning model**. Students move beyond textbooks to
            solve real-world problems using modern tools and technologies.
          </Description>

          <Description>
            These labs encourage **critical thinking, creativity, teamwork, and
            innovation**. Students learn how emerging technologies work and how
            they can be applied in industries such as healthcare, automation,
            smart cities, agriculture, defense, and space research.
          </Description>

          <ImageRow>
            <ImageBox>
              <img src={require("../Assets/Labs/lab5.png")} height={200} width={250} alt="" />
            </ImageBox>
            <ImageBox>
              <img src={require("../Assets/Labs/lab6.png")} height={200} width={250} alt="" />
            </ImageBox>
            <ImageBox>
              <img src={require("../Assets/Labs/lab7.png")} height={200} width={250} alt="" />
            </ImageBox>
            <ImageBox>
              <img src={require("../Assets/Labs/lab8.png")} height={200} width={250} alt="" />
            </ImageBox>
          </ImageRow>

          <BottomTitle>SHAPING THE FUTURE OF STUDENTS</BottomTitle>
          <Description>
            Exposure to robotics and AI at an early stage prepares students for
            future careers in **engineering, data science, AI research,
            automation, and entrepreneurship**. It nurtures innovation and
            inspires students to become creators rather than consumers of
            technology.
          </Description>

          <Description>
            With hands-on projects, real-time problem-solving, and industry
            relevance, students gain confidence and clarity about their career
            paths, making them future-ready for a rapidly evolving technological
            world.
          </Description>
        </BottomContainer>
      </Wrapper>

      <Footer />
    </Container>
  );
};

export default RoboticsAiLabs;